import React from 'react';
import {
  List,
  ListItem,
  ListItemText,
  Button,
  Card,
  CardActions,
  CardContent,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  cardListaVagas: {
    minHeight: 460,
    maxHeight: 460,
  },
  listaVagas: {
    maxHeight: 340,
    minHeight: 340,
    overflow: "auto"
  },
});

export default function ListaVagas(props) {

  const classes = useStyles();

  let itensVagas = [];

  props.detalhesVagas.forEach((vaga, indice) => {
    itensVagas.push(<ListItem key={indice}><ListItemText primary={vaga.title} secondary={vaga.confidential ? "Nome da empresa confidencial" : vaga.company.person.first_name} /></ListItem>);
  })

  return (
    <Card className={classes.cardListaVagas}>
      <CardContent>
        <Typography gutterBottom variant="h5" component="h2">
          Vagas aplicadas
            </Typography>
        <List className={classes.listaVagas}>
          {itensVagas}
        </List>
      </CardContent>
      <CardActions>
      </CardActions>
    </Card>
  );
}